import { fromEmpty, fromNullable } from 'maybeasy';
import { SearchParameters } from '../../../../../ListFilter/Types';
import { getSearchParametersFromUrl } from '../../../../../ListFilter';

const defaultSortParams = () => {
  return [
    { key: 'sort_by', value: 'send_date' },
    { key: 'sort_direction', value: 'desc' },
  ];
};

const addDefaultSortParams = (searchParameters: SearchParameters): SearchParameters =>
  searchParameters.concat(defaultSortParams());

const addDefaultSortParamsIfNotAlreadySorting = (
  searchParameters: SearchParameters,
): SearchParameters =>
  fromNullable(searchParameters.find((searchParameter) => searchParameter.key === 'sort_by'))
    .map(() => searchParameters)
    .getOrElse(() => addDefaultSortParams(searchParameters));

export const searchParametersOrDefault = (): SearchParameters =>
  fromEmpty(getSearchParametersFromUrl())
    .map(addDefaultSortParamsIfNotAlreadySorting)
    .getOrElse(() => defaultSortParams());
